import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import { useAuth } from 'contexts/AuthContext';
import { spacingSizeMap, getTheme } from '@insights-ltd/design-library/themes';
import { TextV2, MarketingCard } from '@insights-ltd/design-library/components';
import { INSIGHTS_BASE_URL } from 'variables';
import { formatList } from 'utils/formatList';
import teamsImage from './ImageAssets/teamsImage.webp';
import digitalProfileImage from './ImageAssets/digitalProfileImage.webp';

const DashboardMarketingPanel = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const availableLanguages = {
    languageList: formatList(
      [
        t('ui.event-management.dialects.english'),
        t('ui.event-management.dialects.danish'),
        t('ui.event-management.dialects.dutch'),
        t('ui.event-management.dialects.french'),
        t('ui.event-management.dialects.german'),
        t('ui.event-management.dialects.spanish'),
      ],
      i18n.language,
    ),
  };

  const localTheme = getTheme();

  const googleAnalyticsTrackingParams = 'utm_source=ncp&utm_medium=ref_';

  const clickHandler = (urlSlug: string) => () =>
    window.open(
      `${INSIGHTS_BASE_URL}${user?.preferredDialect}${urlSlug}?${googleAnalyticsTrackingParams}`,
      '_blank',
    );

  return (
    <>
      <Grid
        sx={(theme) => ({
          marginBottom: theme.spacing(spacingSizeMap.XS),
        })}
      >
        <MarketingCard
          title={t(
            'ui.event-management.marketing.cards.digital-profile.heading',
          )}
          content={t(
            'ui.event-management.marketing.cards.digital-profile.body',
          )}
          image={digitalProfileImage}
          callToAction={t(
            'ui.event-management.marketing.cards.digital-profile.button',
          )}
          handleClick={() =>
            window.open(
              `https://info.insights.com/en/discovery-digital-profile?${googleAnalyticsTrackingParams}`,
              '_blank',
            )
          }
        />
      </Grid>
      <Grid
        sx={(theme) => ({
          marginBottom: theme.spacing(spacingSizeMap.XS),
        })}
      >
        <MarketingCard
          title={t('ui.event-management.marketing.cards.ms-teams.heading', {
            footnote: '*',
          })}
          content={t('ui.event-management.marketing.cards.ms-teams.body')}
          image={teamsImage}
          callToAction={t(
            'ui.event-management.marketing.cards.ms-teams.button',
          )}
          handleClick={clickHandler('/ms-teams')}
        />
      </Grid>
      <TextV2
        variant="body1"
        sx={{
          fontSize: localTheme.typography.size.small,
          marginBottom: '12px',
          width: '340px',
          color: localTheme.grey[700],
        }}
      >
        {`*${t(
          'ui.event-management.marketing.cards.footnote',
          availableLanguages,
        )}`}
      </TextV2>
    </>
  );
};

export default DashboardMarketingPanel;
